import { Link, Navigate, useParams } from "react-router-dom";
import { ArrowLeft, ArrowUpRight, Check } from "lucide-react";
import PageHero from "@/components/PageHero";
import { findFocusArea } from "@/data/focusAreas";

export default function SectorDetailPage({ onEnquiry }) {
  const { slug } = useParams();
  const area = findFocusArea(slug);
  if (!area) return <Navigate to="/focus-areas" replace />;

  return (
    <main data-testid={`sector-page-${area.slug}`}>
      <PageHero eyebrow="Current Focus Area" title={area.title} description={area.summary} image={area.image} testId="sector-page-hero">
        <div className="mt-9 flex flex-wrap gap-4">
          <button data-testid="sector-start-enquiry-cta" onClick={onEnquiry} className="inline-flex items-center gap-3 bg-[#C5A059] px-7 py-4 text-xs font-bold tracking-[0.16em] text-[#1C1613] transition-colors hover:bg-[#D4AF37]">
            START AN ENQUIRY <ArrowUpRight size={16} strokeWidth={1.5} />
          </button>
          <Link data-testid="sector-back-link" to="/focus-areas" className="inline-flex items-center gap-3 border border-[#FDFBF7]/35 px-7 py-4 text-xs font-bold tracking-[0.16em] text-[#FDFBF7] transition-colors hover:border-[#C5A059] hover:text-[#C5A059]">
            <ArrowLeft size={16} strokeWidth={1.5} /> ALL FOCUS AREAS
          </Link>
        </div>
      </PageHero>
      <section className="mx-auto grid max-w-7xl gap-12 px-5 py-20 sm:px-8 lg:grid-cols-[0.9fr_1.1fr] lg:py-28">
        <div>
          <p className="text-sm font-bold uppercase tracking-[0.3em] text-[#C5A059]">Buyer-Led Sourcing</p>
          <h2 className="mt-5 font-serif text-3xl font-normal leading-tight text-[#1C1613] sm:text-4xl">Share the requirement. Keep the possibilities open.</h2>
          <p className="mt-6 text-base font-light leading-8 text-[#524842]">{area.items} This focus area is a starting point, not a catalogue limit; UGI remains open to related products and sectors according to international buyer requirements.</p>
        </div>
        <div className="border border-[#E5DFD3] bg-[#F5F2EB] p-8">
          <h3 className="font-serif text-3xl font-normal text-[#1C1613]">A useful buyer brief can include</h3>
          <ul className="mt-8 grid gap-5">
            {area.brief.map((item) => (
              <li key={item} data-testid={`sector-brief-${item.toLowerCase().replaceAll(" ", "-")}`} className="flex gap-4 text-sm leading-7 text-[#524842]">
                <Check size={18} strokeWidth={1.5} className="mt-1 shrink-0 text-[#C5A059]" />
                {item}
              </li>
            ))}
          </ul>
        </div>
      </section>
    </main>
  );
}
